<template>
  <v-app
    v-if="text"
    data-mark-of-shame
  >
    <BaseAlert
      v-if="hasBackground"
      color="text-error"
      :text="text"
    />
    <div
      v-else
      class="d-flex align-center"
    >
      <div class="ui-icon-circle-info text-error--text mr-2" />
      <div
        class="text-body-2 text-error--text"
      >
        {{ text }}
      </div>
    </div>
  </v-app>
</template>

<script setup>
import I18NextVue from 'i18next'
import BaseAlert from 'www/vue_components/common/core/BaseAlert.vue'
import { ALERT_TEXT_DATA } from 'www/vue_components/common/MarkOfShame/constants'

const { t, language } = I18NextVue

const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  hasBackground: {
    type: Boolean,
    default: false,
  },
})

const text = t(ALERT_TEXT_DATA[props.type] || '', { ns: language })
</script>

<style lang="scss">
@import '~www/themes/doctors/common/mixins';

#app[data-mark-of-shame] {
  @include v-app-reset;
}
</style>
